export default __webpack_public_path__ + "static/media/ss11.aa6eb430.png";